'use strict';
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
          enumerable: true,
          get: function () {
            return m[k];
          },
        });
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
var __setModuleDefault =
  (this && this.__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, 'default', { enumerable: true, value: v });
      }
    : function (o, v) {
        o['default'] = v;
      });
var __importStar =
  (this && this.__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
exports.__esModule = true;
exports.registerPlug =
  exports.getEnabledSlotPlugs =
  exports.resetPlugins =
    void 0;
var UiPlugin = __importStar(require('ui-plugin'));
var plugId = 0;
var plugs = {};
function resetPlugins() {
  UiPlugin.resetPlugins();
  plugs = {};
}
exports.resetPlugins = resetPlugins;
function getEnabledSlotPlugs(slotName) {
  var plugins = UiPlugin.getPlugins();
  return plugs[slotName]
    ? plugs[slotName].filter(function (plug) {
        return plugins[plug.pluginName].enabled;
      })
    : [];
}
exports.getEnabledSlotPlugs = getEnabledSlotPlugs;
function registerPlug(_a) {
  var slotName = _a.slotName,
    pluginName = _a.pluginName,
    component = _a.component,
    plugName = _a.plugName;
  if (!plugs[slotName]) plugs[slotName] = [];
  plugId++;
  plugs[slotName].push({
    id: plugId,
    pluginName: pluginName,
    component: component,
    plugName: plugName,
  });
}
exports.registerPlug = registerPlug;
